export function filterMap(map: Map<any, any>, condition: (k: any, v: any) => {}) {
    const newMap = new Map()
    for (const [key, value] of map) {
        if (condition(key, value)) {
            newMap.set(key, value)
        }
    }
    return newMap
}